module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/im-d637f63b68f97839a27b37c34f1af1a1.svg";